import { Button, useDisclosure } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslations } from 'use-intl';

import {
  SubscriptionInfosFragment,
  UserRole,
  useGetSubscriptionIdentityDocumentsQuery,
} from '@blockpulse3/graphql/hooks';
import { useUser } from '@blockpulse3/web-client/auth';

import { IdentityValidationModal } from './IdentityValidationModal';

type Props = {
  subscriptionId: SubscriptionInfosFragment['id'];
};

export function ConsultIdentityVerification({ subscriptionId }: Props): JSX.Element | null {
  const i18nConsultIdentityVerification = useTranslations('ConsultIdentityVerification');
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { user } = useUser();

  const { data, loading } = useGetSubscriptionIdentityDocumentsQuery({
    variables: {
      subscriptionId,
    },
  });

  const isUserAuthorized = user?.roles.some((role) =>
    [UserRole.COMPLIANCE_OFFICER, UserRole.SUPERADMIN].includes(role),
  );
  const shouldDisplayButton = useMemo(
    () => !data || (data && !data.getSubscriptionIdentityDocuments.length && !isUserAuthorized),
    [data, isUserAuthorized],
  );
  if (shouldDisplayButton) return null;

  return (
    <>
      <Button
        isDisabled={loading}
        isLoading={loading}
        size="sm"
        variant="secondary"
        onClick={onOpen}
      >
        {i18nConsultIdentityVerification('ConsultResults')}
      </Button>
      <IdentityValidationModal isOpen={isOpen} subscriptionId={subscriptionId} onClose={onClose} />
    </>
  );
}
